function syncEbookAccordion(root) {
  const activeTab = root.querySelector('button.updateStudentInstructorOption.active');
  const isEbook = activeTab
    ?.querySelector('.purchase-options-type')
    ?.textContent?.trim()
    .toLowerCase()
    .includes('ebook');
  const isStudent = root.querySelector(
    '.hePdpStuInsToggleBtnGroup .nav-item .nav-link[data-layer-pdp-view-type="student"].active'
  );
  const show = Boolean(isEbook && isStudent);

  root.querySelectorAll('.access_your_ebook').forEach((element) => {
    element.classList.toggle('d-none', !show);
    element.setAttribute('aria-hidden', String(!show));
  });
  const overview = root.querySelectorAll('.overview');
  overview.forEach((element) => element.classList.toggle('border-top', !show));
  if (!overview.length) {
    root.querySelectorAll('.accessibility').forEach((element) => element.classList.toggle('border-top', !show));
  }
}

export function initializeEbookAccordion(root = document) {
  if (!root.querySelector('.hePdpStuInsToggleBtnGroup')) return;
  const update = () => syncEbookAccordion(root);
  root
    .querySelectorAll('.hePdpStuInsToggleBtnGroup .nav-item .nav-link, .updateStudentInstructorOption')
    .forEach((tab) => {
      tab.addEventListener('click', update);
    });
  update();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initializeEbookAccordion(), { once: true });
} else {
  initializeEbookAccordion();
}
